module.exports = __webpack_public_path__ + "img/business.fc115b58.svg";